import React from "react";
import { Handle, Position } from "reactflow";
import { ProfileOutlined } from "@ant-design/icons";

import { useFlowNodes } from "../../../context";

import "./ContextInputIntentNode.scss";
import { ButtonDelete } from "../../ButtonDelete";
import Contexts from "components/Accordion/AccordionIntents/contexts";
import { handleDeleteContextNode } from "../../utils/removeDataNode";

export const ContextInputIntentNode = ({ id }) => {
  const { t, setNodes, setEdges, contexts, ...res } = useFlowNodes();

  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="context-node">
        <div className="context-header">
          <div className="context-title">
            <div className="context-icon">
              <ProfileOutlined />
            </div>
            <span className="context-name">
              {t("common:intents.flow_chat.context.title")}
            </span>
          </div>
          <ButtonDelete
            setNodes={setNodes}
            setEdges={setEdges}
            nodeId={id}
            handleDelete={() => handleDeleteContextNode(res.updateIntent)}
          />
        </div>

        <div className={"accordion__content"}>
          <Contexts
            key="phrases"
            context_type="input"
            contexts={contexts || []}
            {...{
              id,
              setNodes,
              setEdges,
              contexts,
              ...res,
              type: "phrases",
              isFlow: true,
            }}
          />
        </div>
      </div>
    </>
  );
};
